import {JOB_TYPE_FETCHED, JOB_TYPE_UPDATED,} from "./actionType";
import {Action} from "redux-actions";
import {OnFailure, OnSuccessData} from "../actionHelpers";
import {api} from "../../../api/api";
import {Dispatch} from "react-redux";
import JobType from "../../../model/job/JobType";

/**
 * Job types fetched successful action.
 * @return {Action<JOB_TYPE_FETCHED>}
 * @param jobTypes
 */
function jobTypesFetched(jobTypes: Array<JobType>): Action<JOB_TYPE_FETCHED> {
	return {type: JOB_TYPE_FETCHED, payload: {jobTypes}};
}

/**
 * Job type updated successful action.
 * @return {Action<JOB_TYPE_UPDATED>}
 * @param jobType
 */
function jobTypeUpdated(jobType: JobType): Action<JOB_TYPE_UPDATED> {
	return {type: JOB_TYPE_UPDATED, payload: {jobType}};
}

/**
 * Fetch job types from server.
 * @param {OnSuccessData} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function fetchJobTypes(onSuccess: OnSuccessData<JobType[]>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.jobTypeApi.fetchJobTypes().then(jobTypes => {
			dispatch(jobTypesFetched(jobTypes));
			onSuccess(jobTypes);
		}).catch(onFailure);
	};
}

/**
 * Update job type.
 * @param jobTypeId
 * @param jobType
 * @param {OnSuccessData} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function updateJobType(
	jobTypeId: string,
	jobType: JobType,
	onSuccess: OnSuccessData<JobType>,
	onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.jobTypeApi.updateJobType(jobTypeId, jobType).then(jobType => {
			dispatch(jobTypeUpdated(jobType));
			onSuccess(jobType);
		}).catch(onFailure);
	};
}

